export const YAP_DISABLED_MODE = 0;
export const YAP_ENCRYPTED_MODE = 2;
